import { useTranslation } from 'react-i18next'

import CustomerInfoSection from './CustomerInfoSection/CustomerInfoSection'
import LocationInfoSection from './LocationInfoSection/LocationInfoSection'

const ParcelInfoCardInbound = ({
  senderAddress,
  destinationAddress,
  customerEmail,
  onEditInboundOriginAddress,
  allowEditInboundOriginAddress,
  onSendEmailToCustomer,
  allowSendEmail,
  onEditInboundDestinationLocation,
  allowEditInboundDestinationLocation,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <CustomerInfoSection
        title={t('Origen')}
        editTooltip={t('Editar dirección origen')}
        sendEmailTooltip={t('Contactar con el cliente')}
        address={senderAddress}
        email={customerEmail}
        onEdit={onEditInboundOriginAddress}
        allowEdit={allowEditInboundOriginAddress}
        onSendEmail={onSendEmailToCustomer}
        allowSendEmail={allowSendEmail}
      />
      <LocationInfoSection
        title={t('Destino')}
        editTooltip={t('Editar destino')}
        address={destinationAddress}
        locationLabel={t('Enviado a')}
        locationName={t('Ubicación de destino')}
        onEdit={onEditInboundDestinationLocation}
        allowEdit={allowEditInboundDestinationLocation}
      />
    </>
  )
}

export default ParcelInfoCardInbound
